module.exports = __webpack_public_path__ + "media/images/howtoplay3-7404fd0e74bbf2ffe9aabb9076283ac5.png";